/*----------------------------------------
 Check for mobile device type */

function getMobileDeviceType() {
	//detection by browser (user-agent)
	var isMobile = {
		android: function() {
			return navigator.userAgent.match(/Android/i) ? true : false;
		},
		iOS: function() {
			return navigator.userAgent.match(/iPhone|iPad|iPod/i) ||
				(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ? true : false;
		},
		blackberry: function() {
			return navigator.userAgent.match(/BlackBerry|BB10/i) ? true : false;
		},
		windows: function() {
			return navigator.userAgent.match(/IEMobile|Windows Phone/i) ? true : false;
		}
	};

	//check for iOS device
	if(isMobile.iOS()) {
		return 'ios';
	}

	//check for BlackBerry phone
	if(isMobile.blackberry()) {
		return 'blackberry';
	}

	//check for Windows phones
	if(isMobile.windows()) {
		return 'windows';
	}

	//check for android device
	if(isMobile.android()){
		return 'android';
	}
	return false;
}

function getDirectionsBaseUrl() {
	//check for mobile device type
	var device = getMobileDeviceType();
	var baseUrl = '';

	// set default directions base url to google for desktop/android devices
	baseUrl = '//www.google.com/maps/dir/Current+Location/';

	// check for non-android mobile devices and set the base url accordingly
	if(device === 'ios') {
		baseUrl = '//maps.apple.com/maps?daddr=';
	}

	//check for BlackBerry then set URL for BlackBerry maps
	if(device === 'blackberry') {
		baseUrl = 'maps:?address=';
	}

	//check for Windows phone then set URL for Bing maps
	if(device === 'windows') {
		baseUrl = 'bingmaps:?rtp=~pos.';
	}

	return baseUrl;
}

function isMobileExtension() {
	return window.location.href.indexOf('.app.html') > -1;
}

var returnVal = {
	getMobileDeviceType: getMobileDeviceType,
	getDirectionsBaseUrl: getDirectionsBaseUrl,
	isMobileExtension: isMobileExtension
};

export default returnVal;
